module.exports = __webpack_public_path__ + "img/glassquality_3.03037953.png";